// Role constants and groups for route protection
// Centralized definition of user roles and common role combinations

export type UserRole = 'owner' | 'admin' | 'coach' | 'reception' | 'student';

// Common role groups used throughout the application
export const ROLE_GROUPS = {
  // Single role groups
  OWNERS: ['owner'] as const,
  ADMINS: ['owner', 'admin'] as const,

  // Staff combinations (most common)
  STAFF: ['owner', 'admin', 'coach', 'reception'] as const,

  // Specific combinations used in routes
  ALL_STAFF_EXCEPT_OWNERS: ['admin', 'coach', 'reception'] as const,

  // Student access
  STUDENTS: ['student'] as const,

  // Everyone (staff + students)
  ALL: ['owner', 'admin', 'coach', 'reception', 'student'] as const,
} as const;

// Type helpers for role arrays
export type RoleGroup = typeof ROLE_GROUPS[keyof typeof ROLE_GROUPS];
export type RoleArray = readonly UserRole[];

// Helper function to check if a role is in a group
export function hasRole(userRole: UserRole | undefined, allowedRoles: RoleArray): boolean {
  if (!userRole) return false;
  return allowedRoles.includes(userRole);
}

// Helper function to get role group by key
export function getRoleGroup(key: keyof typeof ROLE_GROUPS): RoleArray {
  return ROLE_GROUPS[key];
}